<!--Modal-->

<div class="col-md-5">




    <div class="row">


        <div class="col-md-6">

          <mat-form-field class="example-full-width">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="pickerdos" [(ngModel)]="dateto" >
            <mat-datepicker-toggle matSuffix [for]="pickerdos"></mat-datepicker-toggle>
            <mat-datepicker #pickerdos color="primary"></mat-datepicker>
          </mat-form-field>

        </div>




        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium">
          </mat-form-field>

        </div>




    </div>




    <div class="mat-elevation-z8">

        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">



            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Id. </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="firstname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%"> Firstname </th>
                <td mat-cell *matCellDef="let element"> {{element.firstname}} {{element.lastname}} </td>
            </ng-container>



            <!-- Symbol Column -->
             <ng-container matColumnDef="plate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Plate </th>
                <td mat-cell *matCellDef="let element"> <b> {{ getPlate(element) }} </b>  </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%"> Status </th>
                <td mat-cell *matCellDef="let element">


                    <span class="badge badge-pill badge-success pilas"> Route </span>
                    <!--  <mat-slide-toggle color="primary" [checked]="element.status" [disabled]="true"></mat-slide-toggle>-->
                </td>
            </ng-container>


            <ng-container matColumnDef="imageUrl">
                <th mat-header-cell *matHeaderCellDef style="width: 20%"> Image</th>
                <td mat-cell *matCellDef="let element">
                    <img class="img-responsive" style=" border-radius: 50%; padding: 5px; width: 45px; height: 45px;" [src]="element.img || urlImg" /> </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                <th mat-header-cell *matHeaderCellDef> Symbol </th>
                <td mat-cell *matCellDef="let element">

                    <button class="btn btn-primary" style="width: 40px" (click)="seeRoute(element)"> <i class="fa fa-eye"></i></button>


                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
</div>
<div class="col-md-7">






    <div>


        <div class="col-md-12" id="wrapper" style="margin-top: 55px">

            <div #mapContainer id="map"></div>

            <div class="col-md-4 sh" *ngIf="driver">
              <img [src]="driver.img" style=" border-radius: 50%; padding: 5px; width: 80px; height: 80px; z-index: 9999;">
               <p style="display: block; font-weight: bold; font-size: 16px;">{{ driver.firstname}} {{ driver.lastname}} </p>
          </div>

        </div>
    </div>



</div>
